import React from 'react';
import { Mail, Instagram } from 'lucide-react';

export default function ContactUs() {
  return (
    <section id="contact-us" className="border-subtle bg-canvas border-t py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 lg:text-center">
          <h2 className="text-accent text-base font-semibold tracking-wide uppercase">
            Contact Us
          </h2>
          <p className="font-display text-fg mt-2 text-3xl leading-tight font-semibold tracking-tight sm:text-4xl">
            Get in Touch
          </p>
          <p className="text-fg-muted mt-4 max-w-2xl text-xl lg:mx-auto">
            Have questions or need assistance? Our team is here to help you find the perfect beauty
            experience.
          </p>
        </div>

        <div className="mx-auto grid max-w-3xl grid-cols-1 gap-8 md:grid-cols-2">
          <div className="border-subtle bg-surface flex flex-col items-center rounded-2xl border p-6 shadow-sm">
            <div className="text-accent bg-muted mb-4 flex h-12 w-12 items-center justify-center rounded-full">
              <Mail className="h-6 w-6" />
            </div>
            <h3 className="text-fg text-lg font-medium">Email</h3>
            <a href="mailto:support@calendyz.com" className="hover:text-accent text-fg-muted mt-2">
              support@calendyz.com
            </a>
          </div>

          <div className="border-subtle bg-surface flex flex-col items-center rounded-2xl border p-6 shadow-sm">
            <div className="text-accent bg-muted mb-4 flex h-12 w-12 items-center justify-center rounded-full">
              <Instagram className="h-6 w-6" />
            </div>
            <h3 className="text-fg text-lg font-medium">Instagram</h3>
            <a
              href="https://instagram.com/calendyz"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent text-fg-muted mt-2"
            >
              @calendyz
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
